import { ShopIdParam } from "api/models";
import { apiClient } from "shared/utils";

export const postSubmitQuestionnaire = async ({ shopId }: ShopIdParam) => {
  const { data } = await apiClient.post<boolean>(`questionnaire/${shopId}/submit`);

  return data;
};
